import { render, staticRenderFns } from "./CropsTableController.vue?vue&type=template&id=612e1e7a&scoped=true&"
import script from "./CropsTableController.vue?vue&type=script&lang=ts&"
export * from "./CropsTableController.vue?vue&type=script&lang=ts&"
import style0 from "./CropsTableController.vue?vue&type=style&index=0&id=612e1e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e1e7a",
  null
  
)

export default component.exports